

type ShortTextProps = {
    text: string
    length?: number
}

export const ShortText = ({ text, length = 4 }: ShortTextProps) => {
    const shortText = text?.slice(0, length) + (text.length > 4 ? "..." : "");


    return <span title={text} > {shortText} </span>
}